import React from 'react'
import { Box, Link } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { trimId } from 'src/common/helpers'
import { ChainName } from 'src/common/static'
import { etherscanTxUrl } from '../../utils'
import CopyButton from '../CopyButton/CopyButton'

interface TxHashLinkProps {
  hash: string
  chain?: ChainName
}

// Transaction hashes ARE truncated (unlike wallet addresses) and shown as an explorer link.
const TxHashLink: React.FC<TxHashLinkProps> = ({ hash, chain }) => (
  <Box display="inline-flex" alignItems="center" gap={0.5}>
    <Link
      component="a"
      href={etherscanTxUrl(chain, hash)}
      target="_blank"
      rel="noopener"
      underline="hover"
      sx={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600, color: 'success.dark' }}
    >
      {trimId(hash)}
    </Link>
    <OpenInNewIcon sx={{ fontSize: 12, color: 'success.dark' }} />
    <CopyButton value={hash} title="Copy transaction hash" />
  </Box>
)

export default TxHashLink
